import { defineStore } from "pinia";
import axios from "axios";

export const useMktCalculatorStore = defineStore("mktCalculator", {
  state: () => {
    return {
      sizes: {
        size_a: 0,
        size_b: 0,
        size_c: 0,
        size_d: 0,
      },
      select_offer_id: "",
    };
  },
  actions: {
    openReviewsPopup() {
      this.reviewsPopupOpen = true;
    },
    async getMktData(sizes, offers) {
      return axios({
        method: "post",
        url: "/bitrix/services/main/ajax.php?mode=ajax&c=orteka:mkt.calculator&action=findRightSize",
        params: {
          sizes,
          offers,
        },
      });
    },
  },
  getters: {},
});
